module.exports = __webpack_public_path__ + "img/polar-vortex.b098f0c0.jpg";